import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-bold font-heading text-foreground-50 whitespace-nowrap cursor-pointer">
              <i className="ri-book-open-line text-2xl text-primary-400"></i>
              <span>韩漫漫画</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              韩漫漫画网站汇集免费韩漫在线漫画网站推荐大全，支持无删减下拉式韩漫免费阅读，资源优质更新及时。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-50 mb-4">热门分类</h3>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-50 mb-4">联系我们</h3>
            <ul className="space-y-2.5 text-sm text-foreground-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                <span>contact@hanmancomic.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>韩国首尔特别市江南区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫漫画 hanmancomic.com - 免费韩漫在线推荐大全 All Rights Reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>隐私政策</span>
            <span>用户协议</span>
          </div>
        </div>
      </div>
    </footer>
  );
}